import styled from 'styled-components';

import { AiFillCloseCircle } from 'react-icons/ai';

export const Container = styled.div`
    width: 100vw;
    height: 100%;
    z-index: 10;
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.8);
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    width: 70rem;
    height: auto;
    max-height: 35rem;
    background-color: var(--white);
    box-shadow: 0px 3px 8px 3px rgba(0, 0, 0, 0.3);
    border-radius: 15px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    justify-content: space-between;

    div.text {
        width: 90%;
    }

    h1 {
        font-size: 1.7rem;
        width: 100%;
        color: #333;
    }

    h2 {
        font-size: 1.6rem;
        width: 100%;
        color: #d32f2f;
        font-weight: bold;
    }

    li {
        font-size: 1.5rem;
        width: 100%;
        margin: 0.5rem 0;
    }

    @media (max-width: 950px) {
        width: 50rem;
    }

    @media (max-width: 780px) {
        width: 40rem;
    }

    @media (max-width: 600px) {
        width: 30rem;
    }

    @media (max-width: 440px) {
        width: 25rem;
    }

    @media (max-width: 365px) {
        width: 95%;
        padding: 1.5rem 0.5rem;
    }

    @media (max-height: 730px) {
        height: 75vh;
    }
`;

export const ContainerTitle = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    li {
        text-align: justify;
    }
`;

export const ContainerButtons = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 2rem;
`;

export const CloseButton = styled(AiFillCloseCircle)`
    cursor: pointer;
`;
